import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_ADVISE = "listAdvices";
export const GET_DETAIL_ADVISE = "detailAdvices";
export const SAVE_ADVISE = "saveAdvices";
export const UPDATE_ADVISE = "updateAdvices";
export const DELETE_ADVISE = "deleteAdvices";
export const GET_DATA_SEARCH_ADVISE = "getAdvices";
export const SET_DATA_SEARCH_ADVISE = "setDataSearchAdvices";

export const SET_LIST_ADVISE = "setListAdvices";
export const SET_DETAIL_ADVISE = "setDetailAdvices";


const state = {
    advices_list: [],
    advice: {},
    dataSearch: []
};

const getters = {
    advices(state) {
        return state.advices_list;
    },
    advicesDetail(state) {
        return state.advice;
    },
    dataSearchAdvices(state) {
        return state.dataSearch;
    },
};

const actions = {
    [GET_LIST_ADVISE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_ADVISE, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_ADVISE, data);
                }
                resolve(data);
            });
        });
    },

    [GET_DATA_SEARCH_ADVISE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_ADVISE_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH_ADVISE, data.data.advices);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_ADVISE](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_ADVISE}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_ADVISE, data);
                }
                resolve(data);
            });
        });
    },

    [SAVE_ADVISE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_ADVISE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_ADVISE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_ADVISE}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_ADVISE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_ADVISE}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_ADVISE](state, data) {
        state.advices_list =  data.data
    },
    [SET_DETAIL_ADVISE](state, data) {
        state.advice = data.data;
    },
    [SET_DATA_SEARCH_ADVISE](state, data) {
        state.dataSearch = data
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};